import { useRouter } from "next/router";
import { useSelector } from "react-redux";

import { AppState } from "shared/data/reducers/index";

type ReturnTypes = {
  isMultiCity: boolean;
  travelFrom: string | null;
  travelTo: string | null;
  departureDate: string;
  returnDate: string;
} | null;

const useSearchInfo = (): ReturnTypes => {
  const router = useRouter();

  const { airportDestinations, searchQuery } = useSelector(
    (state: AppState) => ({
      airportDestinations: state.storage.airportDestinations,
      searchQuery: state.storage.searchQuery,
    })
  );

  const isMultiCity =
    Object.keys(searchQuery).includes("flight_1_origin") &&
    Object.keys(searchQuery).includes("flight_1_destination");

  const trafelFromOrigin = isMultiCity
    ? searchQuery.flight_1_origin
    : searchQuery.from;

  const travelToDestination = isMultiCity
    ? searchQuery.flight_1_destination
    : searchQuery.to;

  if (!["/results", "/result"].includes(router.pathname)) {
    return null;
  }

  const originByCode =
    airportDestinations?.find((airport) => airport.Code === trafelFromOrigin)
      ?.$t ??
    trafelFromOrigin ??
    null;

  const destinationByCode =
    airportDestinations?.find((airport) => airport.Code === travelToDestination)
      ?.$t ??
    travelToDestination ??
    null;

  const departureDate = isMultiCity
    ? searchQuery?.flight_1_departureDate
    : searchQuery?.departureDate;

  const returnDate = isMultiCity ? searchQuery?.returnDate : "";

  return {
    isMultiCity,
    travelFrom: originByCode,
    travelTo: destinationByCode,
    departureDate,
    returnDate,
  };
};

export default useSearchInfo;
